import { Badge } from "@/components/ui/badge";

const MAP = {
  success: { label: "Success", cls: "bg-success/15 text-success border-success/30" },
  pending: { label: "Pending", cls: "bg-warning/15 text-warning border-warning/30" },
  utr_submitted: { label: "UTR Submitted", cls: "bg-chart-2/15 text-chart-2 border-chart-2/30" },
  failed: { label: "Failed", cls: "bg-destructive/15 text-destructive border-destructive/30" },
  expired: { label: "Expired", cls: "bg-muted text-muted-foreground border-border" },
  approved: { label: "Approved", cls: "bg-chart-2/15 text-chart-2 border-chart-2/30" },
  paid: { label: "Paid", cls: "bg-success/15 text-success border-success/30" },
  rejected: { label: "Rejected", cls: "bg-destructive/15 text-destructive border-destructive/30" },
  open: { label: "Open", cls: "bg-warning/15 text-warning border-warning/30" },
  resolved: { label: "Resolved", cls: "bg-success/15 text-success border-success/30" },
};

export const StatusBadge = ({ status }) => {
  const s = MAP[status] || MAP.pending;
  return (
    <Badge variant="outline" className={`font-medium ${s.cls}`} data-testid={`status-${status}`}>
      {s.label}
    </Badge>
  );
};
